// extracted by mini-css-extract-plugin
export default {"container":"Temas_container__6EAam","titulo":"Temas_titulo__i15q1"};